var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiltedarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6304 9.56653C19.8291 9.56666 20.0197 9.64566 20.1602 9.7862C20.3008 9.92674 20.3798 10.1173 20.3799 10.3161L20.3799 18.8013C20.3835 18.902 20.3667 19.0023 20.3306 19.0964C20.2946 19.1904 20.2399 19.2762 20.17 19.3487C20.1 19.4212 20.0162 19.4788 19.9235 19.5182C19.8308 19.5575 19.7311 19.5778 19.6304 19.5778C19.5297 19.5778 19.43 19.5575 19.3373 19.5182C19.2445 19.4788 19.1607 19.4212 19.0908 19.3487C19.0208 19.2762 18.9662 19.1904 18.9301 19.0964C18.894 19.0023 18.8773 18.902 18.8808 18.8013L18.8808 12.1263L8.84699 22.1601C8.70634 22.3008 8.51557 22.3798 8.31666 22.3798C8.11775 22.3798 7.92699 22.3008 7.78633 22.1601C7.64568 22.0195 7.56666 21.8287 7.56666 21.6298C7.56666 21.4309 7.64568 21.2401 7.78633 21.0994L17.8202 11.0656L11.1451 11.0656C11.0444 11.0692 10.9441 11.0524 10.8501 11.0163C10.756 10.9803 10.6702 10.9256 10.5977 10.8557C10.5253 10.7857 10.4676 10.7019 10.4283 10.6092C10.3889 10.5165 10.3686 10.4168 10.3686 10.3161C10.3686 10.2153 10.3889 10.1157 10.4283 10.023C10.4676 9.93024 10.5253 9.84641 10.5977 9.77646C10.6702 9.70651 10.756 9.65187 10.8501 9.6158C10.9441 9.57973 11.0444 9.56298 11.1451 9.56653L19.6304 9.56653Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiltedarrow);
export default __webpack_public_path__ + "static/media/tiltedarrow.ca3004fd42adb72a34b50eb21b7c2f7b.svg";
export { ForwardRef as ReactComponent };